const emptyLandmarken = [{ nr: 1, landmarken: "", azimut: NaN, distanz: NaN }];

export default emptyLandmarken;
